var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('h1',{staticClass:"mb-10"},[_vm._v(_vm._s(_vm.$t('login.login')))]),(_vm.error)?_c('div',{staticClass:"error--text mb-4"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('login-form',{on:{"submit":_vm.sendAuthData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }